import { render } from "./spent_products.vue?vue&type=template&id=8a86a97c&scoped=true"
import script from "./spent_products.vue?vue&type=script&lang=js"
export * from "./spent_products.vue?vue&type=script&lang=js"

import "./spent_products.vue?vue&type=style&index=0&id=8a86a97c&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a86a97c"]])

export default __exports__